import { Branch, Category, Node, Type } from '@xanadu/model';
import { TypeMenu } from './type-menu';
import { MenuBuilder } from './menu-builder';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TypeMenuBuilder extends MenuBuilder {

    public Build(node: Node, clipboard: Node): TypeMenu {
        const menu = new TypeMenu();
        if (node instanceof Category) {
            this.forCategory(menu, node);
        } else if (node instanceof Type) {
            this.forType(menu, node);
        }

        this.forEdit(menu, node, clipboard);

        return menu;
    }

    private forCategory(menu: TypeMenu, node: Node): void {
        if (node.isNew) {
            return;
        }

        menu.category = true;
        menu.type = true;
    }

    private forType(menu: TypeMenu, node: Node): void {
    }

    private forEdit(menu: TypeMenu, node: Node, clipboard: Node): void {
        menu.delete = !node._system && (!!node.parentId && (!(node instanceof Branch) || !node.nodes?.length  && !node.branches?.length));
        menu.cut = !!node.parentId;
        menu.copy = !!node.parentId && !(node instanceof Category);
        menu.paste = clipboard && !clipboard.childOf(node) && clipboard.fit(node as Branch) && !node.isNew;
    }
}
